import { UcoastEl } from '@/scripts/core/UcoastEl';
import { getAttributeOrThrow, qsaRequired, qsOptional, qsRequired } from '@/scripts/core/global'
import { routes } from '@/scripts/setup'
import { FacetFiltersForm } from '@/scripts/catalog/facet-filters-form'

export class CollectionToggleQuickAdd extends UcoastEl {
	static htmlSelector = 'collection-toggle-quick-add'
	button: HTMLButtonElement
	path: string
	state: string
	currentQuantity: number
	constructor() {
		super()
		this.button = qsRequired('button', this)
		this.path = getAttributeOrThrow('data-path', this)
		this.state = getAttributeOrThrow('data-state', this)
		this.button.addEventListener('click', this.onButtonClick.bind(this))
		this.currentQuantity = parseInt(getAttributeOrThrow('data-current-quantity', this))
	}

	override connectedCallback() {
		super.connectedCallback()
	}

	reload() {
		this.button = qsRequired('button', this)
		this.path = getAttributeOrThrow('data-path', this)
		this.state = getAttributeOrThrow('data-state', this)
		this.button.addEventListener('click', this.onButtonClick.bind(this))
		this.currentQuantity = parseInt(getAttributeOrThrow('data-current-quantity', this))
	}

	onButtonClick(event: Event) {
		event.preventDefault()
		const nextState = this.getNextState(this.state)
		this.updateDomState(nextState)
		this.state = nextState
		FacetFiltersForm.disableCache()
		if (nextState === 'open') {
			void this.showQuickAdd(event)
		} else {
			void this.hideQuickAdd(event)
		}
	}
	async showQuickAdd(event: Event) {
		const enabled = await this.setQuickAddEnabled()
		if (enabled.success) {
			await this.refresh(event)
		}
	}
	async setQuickAddEnabled() {
		try {
			await fetch(routes.cart_update_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					attributes: {
						'_quick_add': 'true'
					}
				}),
			})
			return {
				success: true
			}
		} catch(e) {
			console.error(e)
			return {
				success: false
			}
		}
	}
	async hideQuickAdd(event: Event) {
		const disabled = await this.setQuickAddDisabled()
		if (disabled.success) {
			await this.refresh(event)
		}
	}
	async setQuickAddDisabled() {
		try {
			await fetch(routes.cart_update_url, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					attributes: {
						'_quick_add': 'false'
					}
				}),
			})
			return {
				success: true
			}
		} catch(e) {
			console.error(e)
			return {
				success: false
			}
		}
	}
	updateDomState(state: 'closed' | 'open' | 'empty') {
		this.state = state
		this.button.setAttribute('data-state', state)
		const stateMarkup = qsaRequired('[data-state-content]', this)
		stateMarkup.forEach((el) => {
			if (el.getAttribute('data-state-content') === state) {
				el.classList.remove('hidden')
			} else {
				el.classList.add('hidden')
			}
		})
		const header = qsOptional('#main-collection-filters') ?? qsOptional('#main-search-filters')
		if (!header) return
		header.setAttribute('data-state', state)
	}
	getNextState(state: string) {
		if (state === 'open' && this.currentQuantity > 0) {
			return 'closed'
		} else if (state === 'open') {
			return 'empty'
		} else {
			return 'open'
		}
	}

	async refresh(event: Event) {
		const nearestFacetFiltersForm = qsOptional<FacetFiltersForm>('facet-filters-form')
		if (!nearestFacetFiltersForm) return
		nearestFacetFiltersForm.onSubmitHandler(event)
	}
}
